<template>
	<v-container class="mt-12 pt-8" style="background:#fafafa;">
		<v-row style="background:#fafafa;">
			
			<v-col cols="12" class="pa-0">
				<v-row class="py-1 px-5">
					<v-col cols="12" md="12" LeadsPannel>
						<v-row>
              <v-col cols="12">
                <div class="elevation-2 pa-0 mb-0" style="font-size:0;border-radius:5px;">
                  <img class="hidden-sm-and-down" style="margin:0;border-radius:5px;" width="100%" :src="`/images/wholesale-banner-pc-${language}.jpg`">
                  <img class="hidden-md-and-up" style="margin:0;border-radius:5px;" width="100%" :src="`/images/wholesale-banner-mobile-${language}.png`">
                </div>
              </v-col>
							<v-col cols="12" LEADSPANEL>
								<v-card :loading="loading">
									<v-card-text class="py-0">
										<v-row class="align-center">
											<v-col cols="12">
												<v-row class="align-center">
													<v-col cols="2" class="text-center" TITLE>
														<v-icon size="40" color="secondary">description</v-icon>
													</v-col>
													<v-col cols="10" TITLE>
														<div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">{{i18n['wholesaleProducts']}}</div>
													</v-col>
												</v-row>
											</v-col>
											<v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<Search :appliedFilters="appliedFilters" :resourceSettings="resourceSettings" @createResource="createResource" @searchResource="loadResource()" />
											</v-col>
											<v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                        <Filters :filters="filters" :appliedFilters="appliedFilters" :resource="resource" />
											</v-col>
											<v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<v-btn color="primary" @click="loadResource()" block :class="`${arabic?'arFont':'enFont'}`">
													{{i18n.filter_results}}
												</v-btn>
											</v-col>
											<v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<Paging :resourceSettings="resourceSettings" :resource="resource" @createResource="createResource"
													@loadResource="loadResource" @pageByNumber="pageByNumber" />
											</v-col>
											<v-col cols="12" class=" py-0">
												<v-row>
													<v-col cols="12" lg="3" md="4" sm="6" v-for="(item, index) in resource.data" :key="'item-'+ index">
														<Product :item="item" :loading="loading" />
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Paging from '../components/Paging.vue';
import Product from './Wholesale/Product.vue'
import Filters from '../components/Filters.vue'
import Search from '../components/Search.vue'

export default {
	components: {
		Paging,
    Product,
    Filters,
		Search
	},
	data() {
		return {
			loading: false,
			resourceSettings: {
				createResource: true,
				resourceName: null,
				search: true,
        searchLabel:'search_product_description',
				create: true,
        master_create:true,
				pagination: true,
			},
			resource: {},
			
			filters:[
        {type:'date', label:'from_date', key:'from_date'},
				{type:'date', label:'to_date', key:'to_date'},
				{type:'select', label:'by_tags', key:'tag_id', items:'tags'},
				{type:'select', label:'origin', icon:'public', key:'origin_country_id', items:'all_countries'},
				{type:'select', label:'ship_to_country', icon:'public', key:'country_id', items:'countries'},
				{type:'number', label:'from_price', key:'from_price'},
				{type:'number', label:'to_price', key:'to_price'},
				{type:'number', label:'from_wharehouse_time', key:'from_wharehouse_time'},
				{type:'number', label:'to_wharehouse_time', key:'to_wharehouse_time'},
				{type:'number', label:'min_order_quantity', key:'min_order_quantity'},
				{type:'select', label:'sort_by', key:'sort_by', items:'sorts'},
				{type:'switch', label:'show_all_products', key:'show_all_products', roles:["master"]},
				{type:'switch', label:'show_expired_products', key:'show_expired_products', roles:["master"]},
			],
			appliedFilters:{},
			search:null,
		}
	},
	methods: {
    details(item) {
			this.$router.push(`/wholesale-product/${item.id}/details`)
		},
		editItem(item) {
			this.$router.push(`/wholesale-product/${item.id}/edit`)
		},
		clipboardSuccessHandler({ value, event }) {
			this.$emit('clipboardSuccessHandler', { value, event });
		},
		async loadResource(page = 1) {
			this.loading = true
			this.resource = await this.$store.dispatch('getResource', { resource: `/wholesale-products?page=${page}`, filters:this.appliedFilters })
			this.loading = false
		},
		async pageByNumber(page) {
			await this.loadResource(page)
		},
		createResource() {
			this.$router.push('/wholesale-product/create')
		}
	},
	computed: {
    language(){
      return this.$store.state.language
    },
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
		master() {
      return this.$store.state.user.role == 'master';
    },
		
	},
	async mounted(page = 1) {
		await this.loadResource()
	}
}
</script>